// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-1:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.table-hover-1 tbody tr:hover td,
.table-hover tbody tr:hover th {
  background-color: whitesmoke;
}

.container2 {
  width: 98%;
  height: 98%;
  padding-right: 5px;
  padding-left: 5px;
  margin-right: 15px !important;
  margin-left: 15px !important;
}

.fluidText {
  font-size: calc(14px + 12 * (100vw - 300px) / 1300);
}

.breadcrumb {
  padding-bottom: 3px !important;
  margin-bottom: 3px !important;
}

.container-fluid {
  padding: 3px !important;
  margin: 3px !important;
}

.card-body {
  padding: 10px !important;
}

.sidebar .nav-link {
  color: whitesmoke;
}

.sidebar .nav-link.active .nav-icon {
  color: whitesmoke;
}

.fa-lg {
  font-size: 1.33333333em !important;
  line-height: 0.75em;
  vertical-align: -15%;
}

body {
  min-width: 320px !important;
  font-family: -apple-system, BlinkMacSystemFont, segoe ui, Roboto, helvetica neue, Arial, noto sans, sans-serif, apple color emoji, segoe ui emoji, segoe ui symbol, noto color emoji;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
}

.sidebar {
  font-size: 13px !important;
}

.settings-menu ul ul li {
  float: none;
  width: auto;
  padding: 5px 0;
  font-weight: 400;
  font-size: 15px !important;
  position: relative;
  padding-left: 22px;
}

.ngx-datatable.material {
  border-style: solid !important;
  border-width: 1px !important;
  border-color: #c8ced3 !important;
  background: #fff !important;
  box-shadow: none !important;
}

.ngx-datatable.material .datatable-header .datatable-header-cell {
  text-align: center !important;
  padding: 0.9rem 1.2rem;
  background-color: whitesmoke !important;
  border-right: #cdcdce;
  border-right-width: 1px;
  border-right-style: solid;
  color: black !important;
  vertical-align: middle !important;
  font-size: 15px;
  font-weight: 700;
}

.ngx-datatable.bootstrap:not(.cell-selection) .datatable-body-row:hover,
.ngx-datatable.material:not(.cell-selection) .datatable-body-row:hover .datatable-row-group {
  background: rgba(187, 255, 187, 0.3843137255) !important;
}

.ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-cell {
  text-align: left;
  padding-left: 0.8rem !important;
  padding-right: 0.8rem !important;
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
  vertical-align: middle;
  border-right: #cdcdce;
  border-right-width: 1px;
  border-right-style: solid;
  border-top: 0;
  border-top-width: 0px;
  border-top-style: initial;
  border-top-color: initial;
  color: rgba(0, 0, 0, 0.87);
  transition: width 0.3s ease;
  font-size: 14px;
  font-weight: 400;
}

.note-group-select-from-files {
  display: none;
}

.settings-menu {
  margin: 0 -12px;
  color: #333;
}

.settings-menu ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.settings-menu ul li {
  float: left;
  width: 25%;
  padding: 12px;
  color: #333;
  font-weight: 500;
  font-size: 16px;
}

.settings-menu ul li a {
  color: #333;
}

.settings-menu ul li:nth-child(4n+1) {
  clear: left;
}

.settings-menu ul ul {
  margin: 10px 0 0 15px;
  border-left: solid 1px #c7c7c7;
}

.settings-menu ul ul li {
  float: none;
  width: auto;
  padding: 5px 0;
  font-weight: 400;
  font-size: 14px;
  position: relative;
  padding-left: 22px;
}

.settings-menu ul ul li:before {
  content: "";
  width: 10px;
  height: 1px;
  background: #c7c7c7;
  position: absolute;
  left: 0;
  top: 15px;
}

@media (max-width: 1199px) {
  .settings-menu ul li {
    width: 33.333%;
  }
  .settings-menu ul li:nth-child(4n+1) {
    clear: none;
  }
  .settings-menu ul li:nth-child(3n+1) {
    clear: left;
  }
}
@media (max-width: 767px) {
  .settings-menu ul li {
    width: 50%;
  }
  .settings-menu ul li:nth-child(3n+1) {
    clear: none;
  }
  .settings-menu ul li:nth-child(2n+1) {
    clear: left;
  }
}
@media (max-width: 479px) {
  .settings-menu ul li {
    width: 100%;
  }
}
.templatesSection {
  height: 800px;
  padding-right: 5px !important;
  padding-left: 5px !important;
  padding-top: 0px !important;
  overflow-x: hidden;
  border: 1px solid rgb(204, 203, 203);
  background-repeat: repeat;
}

.noPadding {
  padding-right: 5px !important;
  padding-left: 5px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.panelChat1 {
  border-radius: 0px;
  background-color: #efefef;
}

.panelChat2 {
  border-radius: 0px;
  background-color: #efefef;
}

.chatSection {
  height: 390px;
  padding: 5px !important;
  background-color: #F8F8F8;
  overflow-x: hidden;
  border: 1px solid rgb(204, 203, 203);
  background-repeat: repeat;
}

.chatSectionLg {
  height: 710px;
  padding-right: 5px !important;
  padding-left: 5px !important;
  padding-top: 0px !important;
  background-color: #F8F8F8;
  overflow-x: hidden;
  border: 1px solid rgb(204, 203, 203);
  background-repeat: repeat;
}

.discussion {
  list-style: none;
  border: solid 1px #e5e5e5;
  margin: 0;
  padding: 25px 0;
}

.discussion li {
  padding: 0.5rem;
  overflow: visible;
  display: flex;
  margin-right: 20px;
  margin-left: 20px;
}

.self {
  justify-content: flex-end;
  align-items: flex-end;
}

.other {
  justify-content: flex-start;
  align-items: flex-start;
}

.messages {
  background: white;
  padding: 12px;
  border-radius: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  position: relative;
}

.messages p {
  font-size: 12px;
  margin: 0 0 0.2rem 0;
  color: #FFF;
}

.messages time {
  font-size: 10px;
  color: #b9b9b9;
  float: right;
  font-weight: 500;
}

.form-group {
  margin-bottom: 0.25rem !important;
}

.col-form-label-static {
  padding: 2px 2px 2px 2px !important;
}

.form-control-static {
  padding: 2px 2px 2px 2px !important;
}

.custom-checkbox {
  padding-top: 5px !important;
}

.myControlSmallLabel {
  font-size: 0.765625rem;
  border-color: transparent;
  background-color: transparent;
}

textarea {
  resize: none !important;
}

.myAccordion .card-header {
  padding: 0px !important;
}

.myAccordion .btn-link {
  font: normal !important;
}

.vl {
  border-right: thin solid rgba(211, 211, 211, 0.767);
}

.cdk-overlay-container {
  z-index: 99999 !important;
}

.cdk-global-scrollblock {
  position: static !important;
  width: initial !important;
  overflow-y: inherit !important;
}

.wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
}

.btn-success {
  background-color: #749F74 !important;
  border-color: #659265 !important;
}

.bg-success {
  background-color: #749F74 !important;
  border-color: #659265 !important;
}

.btn-danger {
  background-color: #a90329 !important;
  border-color: #900323 !important;
}

.btn-primary {
  background-color: #007DAE !important;
  border-color: #007DAE !important;
}

.modal-success .modal-content .modal-header {
  color: #ffffff;
  background-color: #749F74 !important;
}

.modal-success .modal-content {
  border-color: #749F74 !important;
}

.modal-primary .modal-content .modal-header {
  color: #ffffff;
  background-color: #337ab7 !important;
}

.modal-primary .modal-content {
  border-color: #2e6da4 !important;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: whitesmoke;
  opacity: 1;
}

#externalSystemContainer {
  background-color: darkgrey;
  padding: 5px 0 5px 20px;
}

#stripoSettingsContainer {
  width: 400px;
  float: left;
}

#stripoPreviewContainer {
  width: calc(100% - 400px);
  float: left;
}

.notification-zone {
  position: fixed;
  width: 400px;
  z-index: 99999;
  right: 20px;
  bottom: 80px;
}

.control-button {
  border-radius: 17px;
  padding: 5px 10px;
  border-color: grey;
}

#stripoSettingsContainer > div > ul > li {
  width: 180px !important;
}

.ngx-datatable.material.no-campaigns-created .empty-row {
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 25px;
}

mat-sidenav-container.mat-drawer-container.mat-sidenav-container.main-panel {
  z-index: 1041 !important;
}

.nav-link.active {
  color: unset !important;
}

.badge-primary {
  color: #ffffff;
  background-color: #007DAE !important;
}

.fa.fa-arrow-up,
.fa.fa-arrow-down {
  color: #007DAE !important;
}

.btn-outline-primary:hover {
  color: #ffffff !important;
  background-color: #007DAE !important;
  border-color: #007DAE !important;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #333;
  background-color: #ffffff;
  border-color: #c8ced3 #c8ced3 #ffffff;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  color: #858585;
}

.tab-content .tab-pane {
  padding: 1rem;
}

.card-block .tab-content {
  margin-top: 0;
  border: 0;
}

.tab-content {
  margin-top: -1px;
  background: #ffffff;
  border: 1px solid #c8ced3;
  border-radius: 0 0 0.25rem 0.25rem;
}

.btn-secondary,
.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #333;
  background-color: #c8ced3;
  border-color: #c8ced3;
}

.btn-secondary:hover,
.btn-secondary:active {
  color: #333 !important;
  background-color: #c8ced3 !important;
  border-color: #c8ced3 !important;
}

.text-primary,
.btn.btn-link {
  color: #007DAE !important;
}

button.btn.btn-success.btn-sm {
  z-index: unset !important;
}

.mat-drawer.mat-drawer-side {
  z-index: 1 !important;
}

.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.d-flex.flex-wrap {
  gap: 4px;
}

.badge {
  padding: 4px 8px !important;
}

.btn-outline-primary {
  color: #007DAE !important;
}

.date-filter-option > div:nth-child(1) {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 10px;
  padding: 16px 20px;
}

.reset {
  color: #007DAE !important;
  font-weight: 680 !important;
}

.mat-datepicker-content {
  display: flex !important;
  flex-direction: row-reverse;
}

.date-filter-option > div:nth-child(2) {
  padding: 0 0 20px 10px;
}

.mat-datepicker-content-container > .mat-calendar {
  height: auto !important;
}

.mat-calendar-header button span {
  font-weight: bold;
}

.date-filter-option button {
  color: #333;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
  border: 0;
  background: unset;
  font-family: "Open Sans", sans-serif;
}

mat-datepicker-content.mat-datepicker-content.ng-tns-c116-5.ng-trigger.ng-trigger-transformPanel.mat-primary.ng-star-inserted {
  display: flex;
  flex-direction: row-reverse !important;
}

.date-filter-option {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: space-between;
}

.mat-calendar {
  border-left: solid 1px #CCCCCC;
}

.mat-datepicker-actions {
  align-items: unset !important;
}

.reset-button {
  margin-top: 8em;
  background-color: unset;
  border: unset;
  text-align: left;
  color: #007DAE !important;
}

.mat-datepicker-content-container {
  flex-direction: row-reverse !important;
}

.date-action-button-desktop {
  display: flex;
  gap: 5px;
  margin-top: 6em;
  color: #007DAE !important;
  flex-direction: column;
}

@media only screen and (max-width: 768px) {
  .mat-datepicker-content-container {
    flex-direction: unset;
  }
}
@media only screen and (max-width: 560px) {
  .mat-datepicker-content-container {
    flex-direction: unset;
  }
  .date-filter-option button {
    flex-direction: row !important;
    gap: 5px;
    margin-top: unset !important;
  }
}
@media only screen and (max-width: 480px) {
  .mat-datepicker-content-container {
    flex-direction: unset;
  }
  .date-filter-option {
    display: none !important;
  }
}
.datatable-header-cell-label,
.datatable-header-cell {
  word-wrap: break-spaces;
  font-size: 12px !important;
}

.linkTextStyle {
  color: #20a8d8 !important;
}

.clickableLink:hover {
  cursor: pointer !important;
  text-decoration: underline !important;
}

.note-toolbar {
  background-color: white;
  padding-top: 5px !important;
  padding-bottom: 10px !important;
}

.note-icon-caret {
  display: none;
}

.note-btn-group {
  margin-right: 8px;
}

.note-modal-footer {
  height: 70px;
}

.card-1:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.table-hover-1 tbody tr:hover td,
.table-hover tbody tr:hover th {
  background-color: whitesmoke;
}

.container2 {
  width: 98%;
  height: 98%;
  padding-right: 5px;
  padding-left: 5px;
  margin-right: 15px !important;
  margin-left: 15px !important;
}

.fluidText {
  font-size: calc(14px + 12 * (100vw - 300px) / 1300);
}

.breadcrumb {
  padding-bottom: 3px !important;
  margin-bottom: 3px !important;
}

.container-fluid {
  padding: 3px !important;
  margin: 3px !important;
}

.card-body {
  padding: 10px !important;
}

.sidebar .nav-link {
  color: whitesmoke;
}

.sidebar .nav-link.active .nav-icon {
  color: whitesmoke;
}

.fa-lg {
  font-size: 1.33333333em !important;
  line-height: 0.75em;
  vertical-align: -15%;
}

body {
  min-width: 320px !important;
  font-family: -apple-system, BlinkMacSystemFont, segoe ui, Roboto, helvetica neue, Arial, noto sans, sans-serif, apple color emoji, segoe ui emoji, segoe ui symbol, noto color emoji;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
}

.sidebar {
  font-size: 13px !important;
}

.ngx-datatable.material {
  border-style: solid !important;
  border-width: 1px !important;
  border-color: #c8ced3 !important;
  background: #fff !important;
  box-shadow: none !important;
}

.ngx-datatable.material .datatable-header .datatable-header-cell {
  text-align: center !important;
  padding: 0.9rem 1.2rem;
  background-color: whitesmoke !important;
  border-right: #cdcdce;
  border-right-width: 1px;
  border-right-style: solid;
  color: black !important;
  vertical-align: middle !important;
  font-size: 15px;
  font-weight: 700;
}

.ngx-datatable.bootstrap:not(.cell-selection) .datatable-body-row:hover,
.ngx-datatable.material:not(.cell-selection) .datatable-body-row:hover .datatable-row-group {
  background: rgba(187, 255, 187, 0.3843137255) !important;
}

.ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-cell {
  text-align: left;
  padding-left: 0.8rem !important;
  padding-right: 0.8rem !important;
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
  vertical-align: middle;
  border-right: #cdcdce;
  border-right-width: 1px;
  border-right-style: solid;
  border-top: 0;
  border-top-width: 0px;
  border-top-style: initial;
  border-top-color: initial;
  color: rgba(0, 0, 0, 0.87);
  transition: width 0.3s ease;
  font-size: 14px;
  font-weight: 400;
}

.note-group-select-from-files {
  display: none;
}

.settings-menu {
  margin: 0 -12px;
  color: #333;
}

.settings-menu ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.settings-menu ul li {
  float: left;
  width: 25%;
  padding: 12px;
  color: #333;
  font-weight: 500;
  font-size: 16px;
}

.settings-menu ul li a {
  color: #333;
}

.settings-menu ul li:nth-child(4n+1) {
  clear: left;
}

.settings-menu ul ul {
  margin: 10px 0 0 15px;
  border-left: solid 1px #c7c7c7;
}

.settings-menu ul ul li {
  float: none;
  width: auto;
  padding: 5px 0;
  font-weight: 400;
  font-size: 14px;
  position: relative;
  padding-left: 22px;
}

.settings-menu ul ul li:before {
  content: "";
  width: 10px;
  height: 1px;
  background: #c7c7c7;
  position: absolute;
  left: 0;
  top: 15px;
}

@media (max-width: 1199px) {
  .settings-menu ul li {
    width: 33.333%;
  }
  .settings-menu ul li:nth-child(4n+1) {
    clear: none;
  }
  .settings-menu ul li:nth-child(3n+1) {
    clear: left;
  }
}
@media (max-width: 767px) {
  .settings-menu ul li {
    width: 50%;
  }
  .settings-menu ul li:nth-child(3n+1) {
    clear: none;
  }
  .settings-menu ul li:nth-child(2n+1) {
    clear: left;
  }
}
@media (max-width: 479px) {
  .settings-menu ul li {
    width: 100%;
  }
}
.templatesSection {
  height: 800px;
  padding-right: 5px !important;
  padding-left: 5px !important;
  padding-top: 0px !important;
  overflow-x: hidden;
  border: 1px solid rgb(204, 203, 203);
  background-repeat: repeat;
}

.noPadding {
  padding-right: 5px !important;
  padding-left: 5px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.panelChat1 {
  border-radius: 0px;
  background-color: #efefef;
}

.panelChat2 {
  border-radius: 0px;
  background-color: #efefef;
}

.chatSection {
  height: 390px;
  padding: 5px !important;
  background-color: #F8F8F8;
  overflow-x: hidden;
  border: 1px solid rgb(204, 203, 203);
  background-repeat: repeat;
}

.chatSectionLg {
  height: 710px;
  padding-right: 5px !important;
  padding-left: 5px !important;
  padding-top: 0px !important;
  background-color: #F8F8F8;
  overflow-x: hidden;
  border: 1px solid rgb(204, 203, 203);
  background-repeat: repeat;
}

.discussion {
  list-style: none;
  border: solid 1px #e5e5e5;
  margin: 0;
  padding: 25px 0;
}

.discussion li {
  padding: 0.5rem;
  overflow: visible;
  display: flex;
  margin-right: 20px;
  margin-left: 20px;
}

.self {
  justify-content: flex-end;
  align-items: flex-end;
}

.other {
  justify-content: flex-start;
  align-items: flex-start;
}

.messages {
  background: white;
  padding: 12px;
  border-radius: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  position: relative;
}

.messages p {
  font-size: 12px;
  margin: 0 0 0.2rem 0;
  color: #FFF;
}

.messages time {
  font-size: 10px;
  color: #b9b9b9;
  float: right;
  font-weight: 500;
}

.form-group {
  margin-bottom: 0.25rem !important;
}

.col-form-label-static {
  padding: 2px 2px 2px 2px !important;
}

.form-control-static {
  padding: 2px 2px 2px 2px !important;
}

.custom-checkbox {
  padding-top: 5px !important;
}

.myControlSmallLabel {
  font-size: 0.765625rem;
  border-color: transparent;
  background-color: transparent;
}

textarea {
  resize: none !important;
}

.myAccordion .card-header {
  padding: 0px !important;
}

.myAccordion .btn-link {
  font: normal !important;
}

.vl {
  border-right: thin solid rgba(211, 211, 211, 0.767);
}

.cdk-overlay-container {
  z-index: 99999 !important;
}

.cdk-global-scrollblock {
  position: static !important;
  width: initial !important;
  overflow-y: inherit !important;
}

.wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
}

.btn-success {
  background-color: #749F74 !important;
  border-color: #659265 !important;
}

.bg-success {
  background-color: #749F74 !important;
  border-color: #659265 !important;
}

.btn-danger {
  background-color: #a90329 !important;
  border-color: #900323 !important;
}

.btn-primary {
  background-color: #337ab7 !important;
  border-color: #2e6da4 !important;
}

.modal-success .modal-content .modal-header {
  color: #fff;
  background-color: #749F74 !important;
}

.modal-success .modal-content {
  border-color: #749F74 !important;
}

.modal-primary .modal-content .modal-header {
  color: #fff;
  background-color: #337ab7 !important;
}

.modal-primary .modal-content {
  border-color: #2e6da4 !important;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: whitesmoke;
  opacity: 1;
}

#externalSystemContainer {
  background-color: darkgrey;
  padding: 5px 0 5px 20px;
}

#stripoSettingsContainer {
  width: 400px;
  float: left;
}

#stripoPreviewContainer {
  width: calc(100% - 400px);
  float: left;
}

.notification-zone {
  position: fixed;
  width: 400px;
  z-index: 99999;
  right: 20px;
  bottom: 80px;
}

.control-button {
  border-radius: 17px;
  padding: 5px 10px;
  border-color: grey;
}

#stripoSettingsContainer > div > ul > li {
  width: 180px !important;
}

.ngx-datatable.material.no-campaigns-created .empty-row {
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 25px;
}

.mat-active {
  background: #E9F5FB !important;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
  transform: none !important;
}

.mat-select-panel {
  padding: 5px 0 !important;
}

.mat-mdc-form-field-subscript-wrapper {
  height: 0px;
}

.blue-color > span {
  font-weight: 900;
  font-stretch: expanded;
}

.mat-mdc-form-field label {
  color: #858585;
}

.mdc-menu-surface.mat-mdc-autocomplete-panel {
  padding: 0 !important;
}

mat-toolbar.mat-toolbar.mat-toolbar-single-row > div:nth-child(1) {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

mat-toolbar.mat-toolbar.mat-toolbar-single-row > div:nth-child(1) > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

mat-toolbar.mat-toolbar.mat-toolbar-single-row > div:nth-child(1) > div > div:nth-child(1) {
  display: flex;
  align-items: center;
}

.search-wrap .mat-mdc-floating-label,
.search-wrap .mat-mdc-form-field {
  font-size: 14px;
}

.search-wrap .mat-mdc-form-field input {
  margin-top: 2px;
}

.searchDropWrap .mdc-list-item__primary-text {
  width: 100%;
}

.search-wrap .mdc-floating-label--float-above {
  transform: translateY(-26.75px) scale(0.75) !important;
}

.search-wrap div[ng-reflect-open=true] .mdc-notched-outline__notch {
  width: calc(126px * var(--mat-mdc-form-field-floating-label-scale, 0.75) + 9px) !important;
}

.search-wrap label:not(.mdc-floating-label--float-above) .search-lead {
  color: rgba(0, 0, 0, 0.6);
}

.mdc-floating-label {
  will-change: unset !important;
}

.search-wrap mat-icon {
  color: #333;
}

@media only screen and (max-width: 598px) {
  .search-wrap div[ng-reflect-open=true] .mdc-notched-outline__notch {
    display: none;
  }
  .search-wrap .mat-mdc-form-field-infix {
    margin-top: 10px;
  }
  .cdk-overlay-pane {
    width: 100% !important;
    box-shadow: 0px 2px 2px #333;
  }
  .mdc-menu-surface {
    min-width: 100vw !important;
  }
  .mdc-menu-surface.mat-mdc-autocomplete-panel {
    padding: 2px 0 0 0 !important;
  }
  .search-lead {
    display: none;
  }
}
.full-height-weight {
  width: 100%;
  padding-top: 1px;
}

.mat-raised-button:not(.mat-elevation-z) {
  box-shadow: unset !important;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card-body {
  padding: 10px !important;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header-actions {
  display: block;
  float: right;
  margin-right: -0.25rem;
}

.card-header-action {
  padding: 0 0.25rem;
  color: #73818f;
}

.password-hint {
  cursor: default;
  background-color: white;
  border-color: transparent;
  position: absolute;
  right: 7px;
  top: 4px;
  color: darkgray;
  z-index: 10;
  outline: none;
}

button.nx-button {
  background-color: #007DAE;
  color: #ffffff;
  font-weight: 400;
}

.faIcon {
  color: #F0F3F5;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black;
}`, "",{"version":3,"sources":["webpack://./src/scss/_custom.scss","webpack://./src/app/views/init-components/create-password/create-password.component.scss","webpack://./src/scss/angular-materials/nextech-palettes/bw-common-palettes.scss","webpack://./src/scss/nlm-daterangepicker.scss","webpack://./src/scss/nlm-mixed-styles.scss"],"names":[],"mappings":"AA8BA;EACI,4EAAA;AC7BJ;;ADgCA;;EAEI,4BAAA;AC7BJ;;ADgCA;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,4BAAA;AC7BJ;;ADgCA;EACI,mDAAA;AC7BJ;;ADiCA;EACI,8BAAA;EACA,6BAAA;AC9BJ;;ADiCA;EACI,uBAAA;EACA,sBAAA;AC9BJ;;ADiCA;EACI,wBAAA;AC9BJ;;ADkCA;EACI,iBAAA;AC/BJ;;ADoCA;EACI,iBAAA;ACjCJ;;ADqCA;EACI,kCAAA;EACA,mBAAA;EACA,oBAAA;AClCJ;;ADqCA;EACI,2BAAA;EACA,oLAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AClCJ;;ADsCA;EACI,0BAAA;ACnCJ;;ADsCA;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;ACnCJ;;ADuCA;EACI,8BAAA;EACA,4BAAA;EACA,gCAAA;EACA,2BAAA;EACA,2BAAA;ACpCJ;;ADwCA;EACI,6BAAA;EACA,sBAAA;EACA,uCAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;ACrCJ;;ADyCA;;EAEI,wDAAA;ACtCJ;;ADyCA;EACI,gBAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;ACtCJ;;ADyCA;EACI,aAAA;ACtCJ;;AD2CA;EACI,eAAA;EACA,WAAA;ACxCJ;;AD2CA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;ACxCJ;;AD2CA;EACI,WAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;ACxCJ;;AD2CA;EACI,WAAA;ACxCJ;;AD2CA;EACI,WAAA;ACxCJ;;AD2CA;EACI,qBAAA;EACA,8BAAA;ACxCJ;;AD2CA;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;ACxCJ;;AD2CA;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;ACxCJ;;AD2CA;EACI;IACI,cAAA;ECxCN;ED2CE;IACI,WAAA;ECzCN;ED4CE;IACI,WAAA;EC1CN;AACF;AD6CA;EACI;IACI,UAAA;EC3CN;ED8CE;IACI,WAAA;EC5CN;ED+CE;IACI,WAAA;EC7CN;AACF;ADgDA;EACI;IACI,WAAA;EC9CN;AACF;ADkDA;EACI,aAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;AChDJ;;ADqDA;EACI,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;AClDJ;;ADqDA;EACI,kBAAA;EACA,yBAAA;AClDJ;;ADqDA;EACI,kBAAA;EACA,yBAAA;AClDJ;;ADqDA;EACI,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;AClDJ;;ADqDA;EACI,aAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;AClDJ;;ADqDA;EACI,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;AClDJ;;ADqDA;EACI,eAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AClDJ;;ADqDA;EACI,yBAAA;EACA,qBAAA;AClDJ;;ADqDA;EACI,2BAAA;EACA,uBAAA;AClDJ;;ADqDA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;AClDJ;;ADqDA;EACI,eAAA;EACA,oBAAA;EACA,WAAA;AClDJ;;ADqDA;EACI,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AClDJ;;ADsDA;EACI,iCAAA;ACnDJ;;ADsDA;EACI,mCAAA;ACnDJ;;ADsDA;EACI,mCAAA;ACnDJ;;ADsDA;EACI,2BAAA;ACnDJ;;ADsDA;EACI,sBAAA;EACA,yBAAA;EACA,6BAAA;ACnDJ;;ADsDA;EACI,uBAAA;ACnDJ;;ADsDA;EACI,uBAAA;ACnDJ;;ADsDA;EACI,uBAAA;ACnDJ;;ADuDA;EACI,mDAAA;ACpDJ;;ADwDA;EACI,yBAAA;ACrDJ;;ADwDA;EACI,2BAAA;EACA,yBAAA;EACA,8BAAA;ACrDJ;;ADwDA;EACI,aAAA;EACA,qCAAA;EACA,cAAA;ACrDJ;;ADwDA;EACI,oCAAA;EACA,gCAAA;ACrDJ;;ADwDA;EACI,oCAAA;EACA,gCAAA;ACrDJ;;ADwDA;EACI,oCAAA;EACA,gCAAA;ACrDJ;;ADwDA;EACI,oCAAA;EACA,gCAAA;ACrDJ;;ADyDA;EACI,cEraO;EFsaP,oCAAA;ACtDJ;;ADyDA;EACI,gCAAA;ACtDJ;;ADyDA;EACI,cE9aO;EF+aP,oCAAA;ACtDJ;;AD0DA;EACI,gCAAA;ACvDJ;;AD2DA;;EAEI,4BAAA;EACA,UAAA;ACxDJ;;AD6DA;EACI,0BAAA;EACA,uBAAA;AC1DJ;;AD6DA;EACI,YAAA;EACA,WAAA;AC1DJ;;AD6DA;EACI,yBAAA;EACA,WAAA;AC1DJ;;AD6DA;EACI,eAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AC1DJ;;AD6DA;EACI,mBAAA;EACA,iBAAA;EACA,kBAAA;AC1DJ;;AD8DA;EACI,uBAAA;AC3DJ;;ADiEA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AC9DJ;;ADiEA;EACI,wBAAA;AC9DJ;;ADiEA;EACI,uBAAA;AC9DJ;;ADmEA;EACI,cEzfO;EF0fP,oCAAA;AChEJ;;ADmEA;;EAEI,yBAAA;AChEJ;;ADmEA;EACI,yBAAA;EACA,oCAAA;EACA,gCAAA;AChEJ;;ADoEA;;EAEI,WEhhBO;EFihBP,yBE5gBO;EF6gBP,qCAAA;ACjEJ;;ADoEA;EACI,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,cEvhBM;ADsdV;;ADoEA;EACI,aAAA;ACjEJ;;ADoEA;EACI,aAAA;EACA,SAAA;ACjEJ;;ADoEA;EACI,gBAAA;EACA,mBEliBO;EFmiBP,yBAAA;EACA,kCAAA;ACjEJ;;ADuEA;;;EAGI,WEljBO;EFmjBP,yBA9hB6B;EA+hB7B,qBA/hB6B;AC2djC;;ADuEA;;EAEI,sBAAA;EACA,oCAAA;EACA,gCAAA;ACpEJ;;ADyEA;;EAEI,yBAAA;ACtEJ;;ADyEA;EACI,yBAAA;ACtEJ;;ADyEA;EACI,qBAAA;ACtEJ;;ADyEA;EACI,oCAxjBqB;ACkfzB;;ADyEA;EACI,QAAA;ACtEJ;;ADyEA;EACI,2BAAA;ACtEJ;;ADyEA;EACI,yBAAA;ACtEJ;;AEjhBC;EACG,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;AFohBJ;;AEjhBC;EACG,yBAAA;EACA,2BAAA;AFohBJ;;AEjhBC;EACG,wBAAA;EACA,2BAAA;AFohBJ;;AEjhBC;EACG,sBAAA;AFohBJ;;AEjhBC;EACG,uBAAA;AFohBJ;;AEjhBC;EACG,iBAAA;AFohBJ;;AEjhBA;EACI,WDlCO;ECmCP,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,SAAA;EACA,iBAAA;EACA,oCAAA;AFohBJ;;AEhhBC;EACG,aAAA;EACA,sCAAA;AFmhBJ;;AEhhBC;EACG,aAAA;EACA,sBAAA;EACA,SAAA;EACA,8BAAA;AFmhBJ;;AEhhBA;EACI,8BAAA;AFmhBJ;;AEhhBA;EACI,6BAAA;AFmhBJ;;AEhhBA;EACI,eAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;AFmhBJ;;AE/gBA;EACI,sCAAA;AFkhBJ;;AE/gBA;EACI,aAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AFkhBJ;;AE9gBA;EACI;IACI,qBAAA;EFihBN;AACF;AE/gBA;EACI;IACI,qBAAA;EFihBN;EE9gBE;IACI,8BAAA;IACA,QAAA;IACA,4BAAA;EFghBN;AACF;AE9gBA;EACI;IACI,qBAAA;EFghBN;EE9gBE;IACI,wBAAA;EFghBN;AACF;AGznBA;;EAEE,uBAAA;EACA,0BAAA;AH2nBF;;AGxnBA;EACE,yBAAA;AH2nBF;;AGxnBA;EACE,0BAAA;EACA,qCAAA;AH2nBF;;AGxnBA;EACE,uBAAA;EACA,2BAAA;EACA,+BAAA;AH2nBF;;AGxnBA;EACE,aAAA;AH2nBF;;AGxnBA;EACE,iBAAA;AH2nBF;;AGxnBA;EACE,YAAA;AH2nBF;;AGtnBA;EACE,4EAAA;AHynBF;;AGtnBA;;EAEE,4BAAA;AHynBF;;AGtnBA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,4BAAA;AHynBF;;AGtnBA;EACE,mDAAA;AHynBF;;AGrnBA;EACE,8BAAA;EACA,6BAAA;AHwnBF;;AGrnBA;EACE,uBAAA;EACA,sBAAA;AHwnBF;;AGrnBA;EACE,wBAAA;AHwnBF;;AGpnBA;EACE,iBAAA;AHunBF;;AGlnBA;EACE,iBAAA;AHqnBF;;AGjnBA;EACE,kCAAA;EACA,mBAAA;EACA,oBAAA;AHonBF;;AGjnBA;EACE,2BAAA;EACA,oLAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AHonBF;;AGhnBA;EACE,0BAAA;AHmnBF;;AG9mBA;EACE,8BAAA;EACA,4BAAA;EACA,gCAAA;EACA,2BAAA;EACA,2BAAA;AHinBF;;AG7mBA;EACE,6BAAA;EACA,sBAAA;EACA,uCAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AHgnBF;;AG5mBA;;EAEE,wDAAA;AH+mBF;;AG5mBA;EACE,gBAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AH+mBF;;AG5mBA;EACE,aAAA;AH+mBF;;AG1mBA;EACE,eAAA;EACA,WAAA;AH6mBF;;AG1mBA;EACE,UAAA;EACA,SAAA;EACA,gBAAA;AH6mBF;;AG1mBA;EACE,WAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AH6mBF;;AG1mBA;EACE,WAAA;AH6mBF;;AG1mBA;EACE,WAAA;AH6mBF;;AG1mBA;EACE,qBAAA;EACA,8BAAA;AH6mBF;;AGzmBA;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AH4mBF;;AGzmBA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AH4mBF;;AGzmBA;EACE;IACE,cAAA;EH4mBF;EGzmBA;IACE,WAAA;EH2mBF;EGxmBA;IACE,WAAA;EH0mBF;AACF;AGvmBA;EACE;IACE,UAAA;EHymBF;EGtmBA;IACE,WAAA;EHwmBF;EGrmBA;IACE,WAAA;EHumBF;AACF;AGpmBA;EACE;IACE,WAAA;EHsmBF;AACF;AGlmBA;EACE,aAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;AHomBF;;AG/lBA;EACE,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;AHkmBF;;AG/lBA;EACE,kBAAA;EACA,yBAAA;AHkmBF;;AG/lBA;EACE,kBAAA;EACA,yBAAA;AHkmBF;;AG/lBA;EACE,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;AHkmBF;;AG/lBA;EACE,aAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;AHkmBF;;AG/lBA;EACE,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;AHkmBF;;AG/lBA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AHkmBF;;AG/lBA;EACE,yBAAA;EACA,qBAAA;AHkmBF;;AG/lBA;EACE,2BAAA;EACA,uBAAA;AHkmBF;;AG/lBA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;AHkmBF;;AG/lBA;EACE,eAAA;EACA,oBAAA;EACA,WAAA;AHkmBF;;AG/lBA;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AHkmBF;;AG9lBA;EACE,iCAAA;AHimBF;;AG9lBA;EACE,mCAAA;AHimBF;;AG9lBA;EACE,mCAAA;AHimBF;;AG9lBA;EACE,2BAAA;AHimBF;;AG9lBA;EACE,sBAAA;EACA,yBAAA;EACA,6BAAA;AHimBF;;AG9lBA;EACE,uBAAA;AHimBF;;AG9lBA;EACE,uBAAA;AHimBF;;AG9lBA;EACE,uBAAA;AHimBF;;AG7lBA;EACE,mDAAA;AHgmBF;;AG5lBA;EACE,yBAAA;AH+lBF;;AG5lBA;EACE,2BAAA;EACA,yBAAA;EACA,8BAAA;AH+lBF;;AG5lBA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;AH+lBF;;AG5lBA;EACE,oCAAA;EACA,gCAAA;AH+lBF;;AG5lBA;EACE,oCAAA;EACA,gCAAA;AH+lBF;;AG5lBA;EACE,oCAAA;EACA,gCAAA;AH+lBF;;AG5lBA;EACE,oCAAA;EACA,gCAAA;AH+lBF;;AG3lBA;EACE,WAAA;EACA,oCAAA;AH8lBF;;AG1lBA;EACE,gCAAA;AH6lBF;;AG1lBA;EACE,WAAA;EACA,oCAAA;AH6lBF;;AGzlBA;EACE,gCAAA;AH4lBF;;AGxlBA;;EAEE,4BAAA;EACA,UAAA;AH2lBF;;AGtlBA;EACE,0BAAA;EACA,uBAAA;AHylBF;;AGtlBA;EACE,YAAA;EACA,WAAA;AHylBF;;AGtlBA;EACE,yBAAA;EACA,WAAA;AHylBF;;AGtlBA;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AHylBF;;AGtlBA;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;AHylBF;;AGrlBA;EACE,uBAAA;AHwlBF;;AGllBA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AHqlBF;;AGhlBA;EACE,8BAAA;AHmlBF;;AGhlBA;EACE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AHmlBF;;AGhlBA;EACE,yBAAA;AHmlBF;;AG5kBA;EACE,WAAA;AH+kBF;;AG5kBA;EACE,gBAAA;EACA,sBAAA;AH+kBF;;AG5kBA;EACE,cFthBQ;ADqmCV;;AG5kBA;EACE,qBAAA;AH+kBF;;AG5kBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AH+kBF;;AG5kBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AH+kBF;;AG5kBA;EACE,aAAA;EACA,mBAAA;AH+kBF;;AG5kBA;;EAEE,eAAA;AH+kBF;;AG5kBA;EACE,eAAA;AH+kBF;;AG5kBA;EACE,WAAA;AH+kBF;;AG5kBA;EACE,sDAAA;AH+kBF;;AG5kBA;EACE,0FAAA;AH+kBF;;AG5kBA;EACE,yBJ3jBgC;AC0oClC;;AG5kBA;EACE,6BAAA;AH+kBF;;AG5kBA;EACE,WFhlBS;AD+pCX;;AG5kBA;EACE;IACE,aAAA;EH+kBF;EG5kBA;IACE,gBAAA;EH8kBF;EG3kBA;IACE,sBAAA;IACA,4BAAA;EH6kBF;EG1kBA;IACE,2BAAA;EH4kBF;EGzkBA;IACE,6BAAA;EH2kBF;EGxkBA;IACE,aAAA;EH0kBF;AACF;AGtkBA;EACE,WAAA;EACA,gBAAA;AHwkBF;;AGrkBA;EACE,4BAAA;AHwkBF;;AGpkBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,sCAAA;EACA,sBAAA;AHukBF;;AGpkBA;EACE,wBAAA;AHukBF;;AGpkBA;EACE,wBAAA;EACA,gBAAA;EACA,qCAAA;EACA,6CAAA;AHukBF;;AGpkBA;EACE,cAAA;EACA,YAAA;EACA,sBAAA;AHukBF;;AGpkBA;EACE,kBAAA;EACA,cAAA;AHukBF;;AA1tCA;EACE,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;AA6tCF;;AAztCA;EACE,yBCZQ;EDaR,cCfS;EDgBT,gBAAA;AA4tCF;;AAztCA;EACE,cAAA;EACA,8BAAA;EACA,gCAAA;AA4tCF","sourcesContent":["@use '/src/scss/angular-materials/nextech-palettes/bw-common-palettes.scss' as *;\r\n@use '/src/scss/angular-materials/nlm-colors.scss';\r\n\r\n// App specific styles\r\n\r\n// ************************************************\r\n// Main layout left sidebar with icons\r\n// ************************************************\r\n\r\n$nx-nav-bg: #2B2E36;\r\n$nx-nav-hover: #333740;\r\n$nx-nav-sub-bg: #202228;\r\n$nx-light-grey-footer: #f0f0f0;\r\n$nx-dark-grey-search-placeholder: rgba(0, 0, 0, 0.60);\r\n$nx-link-color: #257DBF;\r\n\r\n$nx-blue-color: #337ab7;\r\n$nx-red-color: #f86c6b;\r\n$nx-green-color: #749F74;\r\n$nx-light-blue-color: #66bae5;\r\n\r\n$nx-custom-secondary-gray-color: #c8ced3;\r\n$nx-black-color-opacity: rgba(0, 0, 0, 0.5);\r\n\r\n\r\n// ************************************************\r\n// Dashboard card action \r\n// ************************************************\r\n$nx-mat-option-active: #E9F5FB;\r\n\r\n.card-1:hover {\r\n    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);\r\n}\r\n\r\n.table-hover-1 tbody tr:hover td,\r\n.table-hover tbody tr:hover th {\r\n    background-color: whitesmoke;\r\n}\r\n\r\n.container2 {\r\n    width: 98%;\r\n    height: 98%;\r\n    padding-right: 5px;\r\n    padding-left: 5px;\r\n    margin-right: 15px !important;\r\n    margin-left: 15px !important;\r\n}\r\n\r\n.fluidText {\r\n    font-size: calc(14px + (26 - 14) * ((100vw - 300px) / (1600 - 300)));\r\n}\r\n\r\n\r\n.breadcrumb {\r\n    padding-bottom: 3px !important;\r\n    margin-bottom: 3px !important;\r\n}\r\n\r\n.container-fluid {\r\n    padding: 3px !important;\r\n    margin: 3px !important;\r\n}\r\n\r\n.card-body {\r\n    padding: 10px !important;\r\n}\r\n\r\n//menu text color\r\n.sidebar .nav-link {\r\n    color: whitesmoke;\r\n}\r\n\r\n\r\n//icon color active\r\n.sidebar .nav-link.active .nav-icon {\r\n    color: whitesmoke;\r\n}\r\n\r\n//menu icon\r\n.fa-lg {\r\n    font-size: 1.33333333em !important;\r\n    line-height: .75em;\r\n    vertical-align: -15%;\r\n}\r\n\r\nbody {\r\n    min-width: 320px !important;\r\n    font-family: -apple-system, BlinkMacSystemFont, segoe ui, Roboto, helvetica neue, Arial, noto sans, sans-serif, apple color emoji, segoe ui emoji, segoe ui symbol, noto color emoji;\r\n    font-size: .875rem;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n    text-align: left;\r\n}\r\n\r\n\r\n.sidebar {\r\n    font-size: 13px !important;\r\n}\r\n\r\n.settings-menu ul ul li {\r\n    float: none;\r\n    width: auto;\r\n    padding: 5px 0;\r\n    font-weight: 400;\r\n    font-size: 15px !important;\r\n    position: relative;\r\n    padding-left: 22px;\r\n}\r\n\r\n\r\n.ngx-datatable.material {\r\n    border-style: solid !important;\r\n    border-width: 1px !important;\r\n    border-color: #c8ced3 !important;\r\n    background: #fff !important;\r\n    box-shadow: none !important;\r\n\r\n}\r\n\r\n.ngx-datatable.material .datatable-header .datatable-header-cell {\r\n    text-align: center !important;\r\n    padding: 0.9rem 1.2rem;\r\n    background-color: whitesmoke !important;\r\n    border-right: #cdcdce;\r\n    border-right-width: 1px;\r\n    border-right-style: solid;\r\n    color: black !important;\r\n    vertical-align: middle !important;\r\n    font-size: 15px;\r\n    font-weight: 700;\r\n}\r\n\r\n\r\n.ngx-datatable.bootstrap:not(.cell-selection) .datatable-body-row:hover,\r\n.ngx-datatable.material:not(.cell-selection) .datatable-body-row:hover .datatable-row-group {\r\n    background: #bbffbb62 !important;\r\n}\r\n\r\n.ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-cell {\r\n    text-align: left;\r\n    padding-left: 0.8rem !important;\r\n    padding-right: 0.8rem !important;\r\n    padding-top: 0.3rem !important;\r\n    padding-bottom: 0.3rem !important;\r\n    vertical-align: middle;\r\n    border-right: #cdcdce;\r\n    border-right-width: 1px;\r\n    border-right-style: solid;\r\n    border-top: 0;\r\n    border-top-width: 0px;\r\n    border-top-style: initial;\r\n    border-top-color: initial;\r\n    color: rgba(0, 0, 0, 0.87);\r\n    transition: width 0.3s ease;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n}\r\n\r\n.note-group-select-from-files {\r\n    display: none;\r\n}\r\n\r\n//Settings Menu\r\n\r\n.settings-menu {\r\n    margin: 0 -12px;\r\n    color: #333;\r\n}\r\n\r\n.settings-menu ul {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n}\r\n\r\n.settings-menu ul li {\r\n    float: left;\r\n    width: 25%;\r\n    padding: 12px;\r\n    color: #333;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n}\r\n\r\n.settings-menu ul li a {\r\n    color: #333;\r\n}\r\n\r\n.settings-menu ul li:nth-child(4n+1) {\r\n    clear: left;\r\n}\r\n\r\n.settings-menu ul ul {\r\n    margin: 10px 0 0 15px;\r\n    border-left: solid 1px #c7c7c7;\r\n}\r\n\r\n.settings-menu ul ul li {\r\n    float: none;\r\n    width: auto;\r\n    padding: 5px 0;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    position: relative;\r\n    padding-left: 22px;\r\n}\r\n\r\n.settings-menu ul ul li:before {\r\n    content: '';\r\n    width: 10px;\r\n    height: 1px;\r\n    background: #c7c7c7;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 15px;\r\n}\r\n\r\n@media (max-width:1199px) {\r\n    .settings-menu ul li {\r\n        width: 33.333%;\r\n    }\r\n\r\n    .settings-menu ul li:nth-child(4n+1) {\r\n        clear: none;\r\n    }\r\n\r\n    .settings-menu ul li:nth-child(3n+1) {\r\n        clear: left;\r\n    }\r\n}\r\n\r\n@media (max-width:767px) {\r\n    .settings-menu ul li {\r\n        width: 50%;\r\n    }\r\n\r\n    .settings-menu ul li:nth-child(3n+1) {\r\n        clear: none;\r\n    }\r\n\r\n    .settings-menu ul li:nth-child(2n+1) {\r\n        clear: left;\r\n    }\r\n}\r\n\r\n@media (max-width:479px) {\r\n    .settings-menu ul li {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n\r\n.templatesSection {\r\n    height: 800px;\r\n    padding-right: 5px !important;\r\n    padding-left: 5px !important;\r\n    padding-top: 0px !important;\r\n    overflow-x: hidden;\r\n    border: 1px solid rgb(204, 203, 203);\r\n    background-repeat: repeat;\r\n}\r\n\r\n\r\n// chat\r\n.noPadding {\r\n    padding-right: 5px !important;\r\n    padding-left: 5px !important;\r\n    padding-top: 0px !important;\r\n    padding-bottom: 0px !important;\r\n}\r\n\r\n.panelChat1 {\r\n    border-radius: 0px;\r\n    background-color: #efefef;\r\n}\r\n\r\n.panelChat2 {\r\n    border-radius: 0px;\r\n    background-color: #efefef;\r\n}\r\n\r\n.chatSection {\r\n    height: 390px;\r\n    padding: 5px !important;\r\n    background-color: #F8F8F8;\r\n    overflow-x: hidden;\r\n    border: 1px solid rgb(204, 203, 203);\r\n    background-repeat: repeat;\r\n}\r\n\r\n.chatSectionLg {\r\n    height: 710px;\r\n    padding-right: 5px !important;\r\n    padding-left: 5px !important;\r\n    padding-top: 0px !important;\r\n    background-color: #F8F8F8;\r\n    overflow-x: hidden;\r\n    border: 1px solid rgb(204, 203, 203);\r\n    background-repeat: repeat;\r\n}\r\n\r\n.discussion {\r\n    list-style: none;\r\n    border: solid 1px #e5e5e5;\r\n    margin: 0;\r\n    padding: 25px 0;\r\n}\r\n\r\n.discussion li {\r\n    padding: 0.5rem;\r\n    overflow: visible;\r\n    display: flex;\r\n    margin-right: 20px;\r\n    margin-left: 20px;\r\n}\r\n\r\n.self {\r\n    justify-content: flex-end;\r\n    align-items: flex-end;\r\n}\r\n\r\n.other {\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n}\r\n\r\n.messages {\r\n    background: white;\r\n    padding: 12px;\r\n    border-radius: 20px;\r\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\r\n    position: relative;\r\n}\r\n\r\n.messages p {\r\n    font-size: 12px;\r\n    margin: 0 0 0.2rem 0;\r\n    color: #FFF;\r\n}\r\n\r\n.messages time {\r\n    font-size: 10px;\r\n    color: #b9b9b9;\r\n    float: right;\r\n    font-weight: 500;\r\n}\r\n\r\n//Global\r\n.form-group {\r\n    margin-bottom: 0.25rem !important;\r\n}\r\n\r\n.col-form-label-static {\r\n    padding: 2px 2px 2px 2px !important;\r\n}\r\n\r\n.form-control-static {\r\n    padding: 2px 2px 2px 2px !important;\r\n}\r\n\r\n.custom-checkbox {\r\n    padding-top: 5px !important;\r\n}\r\n\r\n.myControlSmallLabel {\r\n    font-size: 0.765625rem;\r\n    border-color: transparent;\r\n    background-color: transparent;\r\n}\r\n\r\ntextarea {\r\n    resize: none !important;\r\n}\r\n\r\n.myAccordion .card-header {\r\n    padding: 0px !important;\r\n}\r\n\r\n.myAccordion .btn-link {\r\n    font: normal !important;\r\n}\r\n\r\n\r\n.vl {\r\n    border-right: thin solid rgba(211, 211, 211, 0.767);\r\n}\r\n\r\n\r\n.cdk-overlay-container {\r\n    z-index: 99999 !important;\r\n}\r\n\r\n.cdk-global-scrollblock {\r\n    position: static !important;\r\n    width: initial !important;\r\n    overflow-y: inherit !important;\r\n}\r\n\r\n.wrapper {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-gap: 10px;\r\n}\r\n\r\n.btn-success {\r\n    background-color: #749F74 !important;\r\n    border-color: #659265 !important;\r\n}\r\n\r\n.bg-success {\r\n    background-color: #749F74 !important;\r\n    border-color: #659265 !important;\r\n}\r\n\r\n.btn-danger {\r\n    background-color: #a90329 !important;\r\n    border-color: #900323 !important;\r\n}\r\n\r\n.btn-primary {\r\n    background-color: $nx-info !important;\r\n    border-color: $nx-info  !important;\r\n}\r\n\r\n\r\n.modal-success .modal-content .modal-header {\r\n    color: $nx-white;\r\n    background-color: $nx-green-color !important;\r\n}\r\n\r\n.modal-success .modal-content {\r\n    border-color: $nx-green-color !important;\r\n}\r\n\r\n.modal-primary .modal-content .modal-header {\r\n    color: $nx-white;\r\n    background-color: $nx-blue-color !important;\r\n\r\n}\r\n\r\n.modal-primary .modal-content {\r\n    border-color: #2e6da4 !important;\r\n}\r\n\r\n\r\n.form-control:disabled,\r\n.form-control[readonly] {\r\n    background-color: whitesmoke;\r\n    opacity: 1;\r\n}\r\n\r\n/////-----------------------------------------------------------------------------\r\n// stripo\r\n#externalSystemContainer {\r\n    background-color: darkgrey;\r\n    padding: 5px 0 5px 20px;\r\n}\r\n\r\n#stripoSettingsContainer {\r\n    width: 400px;\r\n    float: left;\r\n}\r\n\r\n#stripoPreviewContainer {\r\n    width: calc(100% - 400px);\r\n    float: left;\r\n}\r\n\r\n.notification-zone {\r\n    position: fixed;\r\n    width: 400px;\r\n    z-index: 99999;\r\n    right: 20px;\r\n    bottom: 80px;\r\n}\r\n\r\n.control-button {\r\n    border-radius: 17px;\r\n    padding: 5px 10px;\r\n    border-color: grey;\r\n}\r\n\r\n\r\n#stripoSettingsContainer>div>ul>li {\r\n    width: 180px !important;\r\n}\r\n\r\n\r\n/////-----------------------------------------------------------------------------\r\n// campaign list\r\n.ngx-datatable.material.no-campaigns-created .empty-row {\r\n    height: 350px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-weight: 500;\r\n    font-size: 25px;\r\n}\r\n\r\nmat-sidenav-container.mat-drawer-container.mat-sidenav-container.main-panel {\r\n    z-index: 1041 !important;\r\n}\r\n\r\n.nav-link.active {\r\n    color: unset !important;\r\n}\r\n\r\n\r\n\r\n.badge-primary {\r\n    color: $nx-white;\r\n    background-color: $nx-info !important;\r\n}\r\n\r\n.fa.fa-arrow-up,\r\n.fa.fa-arrow-down {\r\n    color: $nx-info !important;\r\n}\r\n\r\n.btn-outline-primary:hover {\r\n    color: $nx-white !important;\r\n    background-color: $nx-info !important;\r\n    border-color: $nx-info !important;\r\n}\r\n\r\n// \r\n.nav-tabs .nav-link.active,\r\n.nav-tabs .nav-item.show .nav-link {\r\n    color: $nx-black;\r\n    background-color: $nx-white;\r\n    border-color: $nx-custom-secondary-gray-color $nx-custom-secondary-gray-color $nx-white;\r\n}\r\n\r\n.nav-tabs .nav-link {\r\n    border: 1px solid transparent;\r\n    border-top-left-radius: .25rem;\r\n    border-top-right-radius: .25rem;\r\n    color: $nx-grey;\r\n}\r\n\r\n.tab-content .tab-pane {\r\n    padding: 1rem;\r\n}\r\n\r\n.card-block .tab-content {\r\n    margin-top: 0;\r\n    border: 0\r\n}\r\n\r\n.tab-content {\r\n    margin-top: -1px;\r\n    background: $nx-white;\r\n    border: 1px solid $nx-custom-secondary-gray-color;\r\n    border-radius: 0 0 .25rem .25rem;\r\n}\r\n\r\n// \r\n\r\n\r\n.btn-secondary,\r\n.btn-secondary.disabled,\r\n.btn-secondary:disabled {\r\n    color: $nx-black;\r\n    background-color: $nx-custom-secondary-gray-color;\r\n    border-color: $nx-custom-secondary-gray-color;\r\n}\r\n\r\n.btn-secondary:hover,\r\n.btn-secondary:active {\r\n    color: $nx-black !important;\r\n    background-color: $nx-custom-secondary-gray-color !important;\r\n    border-color: $nx-custom-secondary-gray-color !important;\r\n}\r\n\r\n//**** Start - Change Bootstrap Color ****\r\n\r\n.text-primary,\r\n.btn.btn-link {\r\n    color: $nx-info !important;\r\n}\r\n\r\nbutton.btn.btn-success.btn-sm {\r\n    z-index: unset !important;\r\n}\r\n\r\n.mat-drawer.mat-drawer-side {\r\n    z-index: 1 !important;\r\n}\r\n\r\n.modal {\r\n    background-color: $nx-black-color-opacity\r\n}\r\n\r\n.d-flex.flex-wrap {\r\n    gap: 4px;\r\n}\r\n\r\n.badge {\r\n    padding: 4px 8px !important;\r\n}\r\n\r\n.btn-outline-primary {\r\n    color: $nx-info !important;\r\n}\r\n\r\n//**** End - Change Bootstrap Color ****","@use '/src/scss/angular-materials/nextech-palettes/bw-common-palettes.scss' as *;\r\n@use '/src/scss/custom.scss' as *;\r\n@use '/src/scss/nlm-mixed-styles.scss' as *;\r\n\r\n\r\n.password-hint {\r\n  cursor: default;\r\n  background-color: white;\r\n  border-color: transparent;\r\n  position: absolute;\r\n  right: 7px;\r\n  top: 4px;\r\n  color: darkgray;\r\n  z-index: 10;\r\n  outline: none;\r\n}\r\n\r\n\r\nbutton.nx-button {\r\n  background-color: $nx-info;\r\n  color: $nx-white;\r\n  font-weight: 400;\r\n}\r\n\r\n.faIcon {\r\n  color: #F0F3F5;\r\n  -webkit-text-stroke-width: 1px; \r\n  -webkit-text-stroke-color: black\r\n}\r\n","$nx-black: #333;\r\n$nx-dark-grey: #6B6B6B;\r\n$nx-grey: #858585;\r\n$nx-light-grey: #CCCCCC;\r\n$nx-washed-grey: #F8F8F8;\r\n$nx-white: #ffffff;\r\n\r\n$nx-info: #007DAE;\r\n$nx-success: #2D841F;\r\n$nx-caution: #CF811C;\r\n$nx-warn: #D0021B;\r\n\r\n$opacity-10-pct: .10;\r\n$opacity-25-pct: .25;\r\n$opacity-50-pct: .50;\r\n$opacity-75-pct: .75;\r\n\r\n$nx-black-contrast: $nx-white;\r\n$nx-dark-grey-contrast: $nx-white;\r\n$nx-grey-contrast: $nx-white;\r\n$nx-light-grey-contrast: $nx-black;\r\n$nx-washed-grey-contrast: $nx-black;\r\n$nx-white-contrast: $nx-black;\r\n\r\n$nx-grey-scheme: (\r\n  nx-black: $nx-black,\r\n  nx-dark-grey: $nx-dark-grey,\r\n  nx-grey: $nx-grey,\r\n  nx-light-grey: $nx-light-grey,\r\n  nx-washed-grey: $nx-washed-grey,\r\n  nx-white: $nx-white,\r\n  contrast: (\r\n    nx-black: $nx-black-contrast,\r\n    nx-dark-grey: $nx-dark-grey-contrast,\r\n    nx-grey: $nx-grey-contrast,\r\n    nx-light-grey: $nx-light-grey-contrast,\r\n    nx-washed-grey: $nx-washed-grey-contrast,\r\n    nx-white: $nx-white-contrast,\r\n  ),\r\n);\r\n","@use '/src/scss/angular-materials/nextech-palettes/bw-common-palettes.scss' as *;\r\n@use '/src/scss/custom.scss' as *;\r\n\r\n .date-filter-option>div:nth-child(1) {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: baseline;\r\n    gap: 10px;\r\n    padding: 16px 20px;\r\n}\r\n\r\n .reset {\r\n    color: $nx-info !important;\r\n    font-weight: 680 !important;\r\n}\r\n\r\n .mat-datepicker-content {\r\n    display: flex !important;\r\n    flex-direction: row-reverse;\r\n}\r\n\r\n .date-filter-option>div:nth-child(2) {\r\n    padding: 0 0 20px 10px;\r\n}\r\n\r\n .mat-datepicker-content-container>.mat-calendar {\r\n    height: auto !important;\r\n}\r\n\r\n .mat-calendar-header button span {\r\n    font-weight: bold;\r\n}\r\n\r\n.date-filter-option button {\r\n    color: $nx-black;\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    line-height: 20px;\r\n    word-wrap: break-word;\r\n    border: 0;\r\n    background: unset;\r\n    font-family: 'Open Sans', sans-serif;\r\n}\r\n\r\n\r\n mat-datepicker-content.mat-datepicker-content.ng-tns-c116-5.ng-trigger.ng-trigger-transformPanel.mat-primary.ng-star-inserted {\r\n    display: flex;\r\n    flex-direction: row-reverse !important;\r\n}\r\n\r\n .date-filter-option {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    justify-content: space-between;\r\n}\r\n\r\n.mat-calendar {\r\n    border-left: solid 1px $nx-light-grey;\r\n}\r\n\r\n.mat-datepicker-actions {\r\n    align-items: unset !important;\r\n}\r\n\r\n.reset-button {\r\n    margin-top: 8em;\r\n    background-color: unset;\r\n    border: unset;\r\n    text-align: left;\r\n    color: $nx-info !important;\r\n}\r\n\r\n\r\n.mat-datepicker-content-container {\r\n    flex-direction: row-reverse !important;\r\n}\r\n\r\n.date-action-button-desktop {\r\n    display: flex;\r\n    gap: 5px;\r\n    margin-top: 6em;\r\n    color: $nx-info !important;\r\n    flex-direction: column;\r\n}\r\n\r\n\r\n@media only screen and (max-width: 768px) {\r\n    .mat-datepicker-content-container {\r\n        flex-direction: unset;\r\n    }\r\n}\r\n@media only screen and (max-width: 560px) {\r\n    .mat-datepicker-content-container {\r\n        flex-direction: unset;\r\n    }\r\n\r\n    .date-filter-option button {\r\n        flex-direction: row !important;\r\n        gap: 5px;\r\n        margin-top: unset !important;\r\n    }\r\n}\r\n@media only screen and (max-width: 480px) {\r\n    .mat-datepicker-content-container {\r\n        flex-direction: unset;\r\n    }\r\n    .date-filter-option {\r\n        display: none !important;\r\n    }\r\n}\r\n","@use '/src/scss/angular-materials/nextech-palettes/bw-common-palettes.scss' as *;\r\n@use '/src/scss/_custom.scss' as *;\r\n@use '/src/scss/nlm-daterangepicker.scss' as *;\r\n\r\n.datatable-header-cell-label,\r\n.datatable-header-cell {\r\n  word-wrap: break-spaces;\r\n  font-size: 12px !important;\r\n}\r\n\r\n.linkTextStyle {\r\n  color: #20a8d8 !important;\r\n}\r\n\r\n.clickableLink:hover {\r\n  cursor: pointer !important;\r\n  text-decoration: underline !important;\r\n}\r\n\r\n.note-toolbar {\r\n  background-color: white;\r\n  padding-top: 5px !important;\r\n  padding-bottom: 10px !important;\r\n}\r\n\r\n.note-icon-caret {\r\n  display: none;\r\n}\r\n\r\n.note-btn-group {\r\n  margin-right: 8px;\r\n}\r\n\r\n.note-modal-footer {\r\n  height: 70px;\r\n}\r\n\r\n\r\n\r\n.card-1:hover {\r\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);\r\n}\r\n\r\n.table-hover-1 tbody tr:hover td,\r\n.table-hover tbody tr:hover th {\r\n  background-color: whitesmoke;\r\n}\r\n\r\n.container2 {\r\n  width: 98%;\r\n  height: 98%;\r\n  padding-right: 5px;\r\n  padding-left: 5px;\r\n  margin-right: 15px !important;\r\n  margin-left: 15px !important;\r\n}\r\n\r\n.fluidText {\r\n  font-size: calc(14px + (26 - 14) * ((100vw - 300px) / (1600 - 300)));\r\n}\r\n\r\n\r\n.breadcrumb {\r\n  padding-bottom: 3px !important;\r\n  margin-bottom: 3px !important;\r\n}\r\n\r\n.container-fluid {\r\n  padding: 3px !important;\r\n  margin: 3px !important;\r\n}\r\n\r\n.card-body {\r\n  padding: 10px !important;\r\n}\r\n\r\n//menu text color\r\n.sidebar .nav-link {\r\n  color: whitesmoke;\r\n}\r\n\r\n\r\n//icon color active\r\n.sidebar .nav-link.active .nav-icon {\r\n  color: whitesmoke;\r\n}\r\n\r\n//menu icon\r\n.fa-lg {\r\n  font-size: 1.33333333em !important;\r\n  line-height: .75em;\r\n  vertical-align: -15%;\r\n}\r\n\r\nbody {\r\n  min-width: 320px !important;\r\n  font-family: -apple-system, BlinkMacSystemFont, segoe ui, Roboto, helvetica neue, Arial, noto sans, sans-serif, apple color emoji, segoe ui emoji, segoe ui symbol, noto color emoji;\r\n  font-size: .875rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  text-align: left;\r\n}\r\n\r\n\r\n.sidebar {\r\n  font-size: 13px !important;\r\n}\r\n\r\n\r\n\r\n.ngx-datatable.material {\r\n  border-style: solid !important;\r\n  border-width: 1px !important;\r\n  border-color: #c8ced3 !important;\r\n  background: #fff !important;\r\n  box-shadow: none !important;\r\n\r\n}\r\n\r\n.ngx-datatable.material .datatable-header .datatable-header-cell {\r\n  text-align: center !important;\r\n  padding: 0.9rem 1.2rem;\r\n  background-color: whitesmoke !important;\r\n  border-right: #cdcdce;\r\n  border-right-width: 1px;\r\n  border-right-style: solid;\r\n  color: black !important;\r\n  vertical-align: middle !important;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n}\r\n\r\n\r\n.ngx-datatable.bootstrap:not(.cell-selection) .datatable-body-row:hover,\r\n.ngx-datatable.material:not(.cell-selection) .datatable-body-row:hover .datatable-row-group {\r\n  background: #bbffbb62 !important;\r\n}\r\n\r\n.ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-cell {\r\n  text-align: left;\r\n  padding-left: 0.8rem !important;\r\n  padding-right: 0.8rem !important;\r\n  padding-top: 0.3rem !important;\r\n  padding-bottom: 0.3rem !important;\r\n  vertical-align: middle;\r\n  border-right: #cdcdce;\r\n  border-right-width: 1px;\r\n  border-right-style: solid;\r\n  border-top: 0;\r\n  border-top-width: 0px;\r\n  border-top-style: initial;\r\n  border-top-color: initial;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  transition: width 0.3s ease;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n}\r\n\r\n.note-group-select-from-files {\r\n  display: none;\r\n}\r\n\r\n//Settings Menu\r\n\r\n.settings-menu {\r\n  margin: 0 -12px;\r\n  color: #333;\r\n}\r\n\r\n.settings-menu ul {\r\n  padding: 0;\r\n  margin: 0;\r\n  list-style: none;\r\n}\r\n\r\n.settings-menu ul li {\r\n  float: left;\r\n  width: 25%;\r\n  padding: 12px;\r\n  color: #333;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n}\r\n\r\n.settings-menu ul li a {\r\n  color: #333;\r\n}\r\n\r\n.settings-menu ul li:nth-child(4n+1) {\r\n  clear: left;\r\n}\r\n\r\n.settings-menu ul ul {\r\n  margin: 10px 0 0 15px;\r\n  border-left: solid 1px #c7c7c7;\r\n}\r\n\r\n\r\n.settings-menu ul ul li {\r\n  float: none;\r\n  width: auto;\r\n  padding: 5px 0;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  position: relative;\r\n  padding-left: 22px;\r\n}\r\n\r\n.settings-menu ul ul li:before {\r\n  content: '';\r\n  width: 10px;\r\n  height: 1px;\r\n  background: #c7c7c7;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 15px;\r\n}\r\n\r\n@media (max-width:1199px) {\r\n  .settings-menu ul li {\r\n    width: 33.333%;\r\n  }\r\n\r\n  .settings-menu ul li:nth-child(4n+1) {\r\n    clear: none;\r\n  }\r\n\r\n  .settings-menu ul li:nth-child(3n+1) {\r\n    clear: left;\r\n  }\r\n}\r\n\r\n@media (max-width:767px) {\r\n  .settings-menu ul li {\r\n    width: 50%;\r\n  }\r\n\r\n  .settings-menu ul li:nth-child(3n+1) {\r\n    clear: none;\r\n  }\r\n\r\n  .settings-menu ul li:nth-child(2n+1) {\r\n    clear: left;\r\n  }\r\n}\r\n\r\n@media (max-width:479px) {\r\n  .settings-menu ul li {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n\r\n.templatesSection {\r\n  height: 800px;\r\n  padding-right: 5px !important;\r\n  padding-left: 5px !important;\r\n  padding-top: 0px !important;\r\n  overflow-x: hidden;\r\n  border: 1px solid rgb(204, 203, 203);\r\n  background-repeat: repeat;\r\n}\r\n\r\n\r\n// chat\r\n.noPadding {\r\n  padding-right: 5px !important;\r\n  padding-left: 5px !important;\r\n  padding-top: 0px !important;\r\n  padding-bottom: 0px !important;\r\n}\r\n\r\n.panelChat1 {\r\n  border-radius: 0px;\r\n  background-color: #efefef;\r\n}\r\n\r\n.panelChat2 {\r\n  border-radius: 0px;\r\n  background-color: #efefef;\r\n}\r\n\r\n.chatSection {\r\n  height: 390px;\r\n  padding: 5px !important;\r\n  background-color: #F8F8F8;\r\n  overflow-x: hidden;\r\n  border: 1px solid rgb(204, 203, 203);\r\n  background-repeat: repeat;\r\n}\r\n\r\n.chatSectionLg {\r\n  height: 710px;\r\n  padding-right: 5px !important;\r\n  padding-left: 5px !important;\r\n  padding-top: 0px !important;\r\n  background-color: #F8F8F8;\r\n  overflow-x: hidden;\r\n  border: 1px solid rgb(204, 203, 203);\r\n  background-repeat: repeat;\r\n}\r\n\r\n.discussion {\r\n  list-style: none;\r\n  border: solid 1px #e5e5e5;\r\n  margin: 0;\r\n  padding: 25px 0;\r\n}\r\n\r\n.discussion li {\r\n  padding: 0.5rem;\r\n  overflow: visible;\r\n  display: flex;\r\n  margin-right: 20px;\r\n  margin-left: 20px;\r\n}\r\n\r\n.self {\r\n  justify-content: flex-end;\r\n  align-items: flex-end;\r\n}\r\n\r\n.other {\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.messages {\r\n  background: white;\r\n  padding: 12px;\r\n  border-radius: 20px;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\r\n  position: relative;\r\n}\r\n\r\n.messages p {\r\n  font-size: 12px;\r\n  margin: 0 0 0.2rem 0;\r\n  color: #FFF;\r\n}\r\n\r\n.messages time {\r\n  font-size: 10px;\r\n  color: #b9b9b9;\r\n  float: right;\r\n  font-weight: 500;\r\n}\r\n\r\n//Global\r\n.form-group {\r\n  margin-bottom: 0.25rem !important;\r\n}\r\n\r\n.col-form-label-static {\r\n  padding: 2px 2px 2px 2px !important;\r\n}\r\n\r\n.form-control-static {\r\n  padding: 2px 2px 2px 2px !important;\r\n}\r\n\r\n.custom-checkbox {\r\n  padding-top: 5px !important;\r\n}\r\n\r\n.myControlSmallLabel {\r\n  font-size: 0.765625rem;\r\n  border-color: transparent;\r\n  background-color: transparent;\r\n}\r\n\r\ntextarea {\r\n  resize: none !important;\r\n}\r\n\r\n.myAccordion .card-header {\r\n  padding: 0px !important;\r\n}\r\n\r\n.myAccordion .btn-link {\r\n  font: normal !important;\r\n}\r\n\r\n\r\n.vl {\r\n  border-right: thin solid rgba(211, 211, 211, 0.767);\r\n}\r\n\r\n\r\n.cdk-overlay-container {\r\n  z-index: 99999 !important;\r\n}\r\n\r\n.cdk-global-scrollblock {\r\n  position: static !important;\r\n  width: initial !important;\r\n  overflow-y: inherit !important;\r\n}\r\n\r\n.wrapper {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  grid-gap: 10px;\r\n}\r\n\r\n.btn-success {\r\n  background-color: #749F74 !important;\r\n  border-color: #659265 !important;\r\n}\r\n\r\n.bg-success {\r\n  background-color: #749F74 !important;\r\n  border-color: #659265 !important;\r\n}\r\n\r\n.btn-danger {\r\n  background-color: #a90329 !important;\r\n  border-color: #900323 !important;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: #337ab7 !important;\r\n  border-color: #2e6da4 !important;\r\n}\r\n\r\n\r\n.modal-success .modal-content .modal-header {\r\n  color: #fff;\r\n  background-color: #749F74 !important;\r\n}\r\n\r\n\r\n.modal-success .modal-content {\r\n  border-color: #749F74 !important;\r\n}\r\n\r\n.modal-primary .modal-content .modal-header {\r\n  color: #fff;\r\n  background-color: #337ab7 !important;\r\n\r\n}\r\n\r\n.modal-primary .modal-content {\r\n  border-color: #2e6da4 !important;\r\n}\r\n\r\n\r\n.form-control:disabled,\r\n.form-control[readonly] {\r\n  background-color: whitesmoke;\r\n  opacity: 1;\r\n}\r\n\r\n/////-----------------------------------------------------------------------------\r\n// stripo\r\n#externalSystemContainer {\r\n  background-color: darkgrey;\r\n  padding: 5px 0 5px 20px;\r\n}\r\n\r\n#stripoSettingsContainer {\r\n  width: 400px;\r\n  float: left;\r\n}\r\n\r\n#stripoPreviewContainer {\r\n  width: calc(100% - 400px);\r\n  float: left;\r\n}\r\n\r\n.notification-zone {\r\n  position: fixed;\r\n  width: 400px;\r\n  z-index: 99999;\r\n  right: 20px;\r\n  bottom: 80px;\r\n}\r\n\r\n.control-button {\r\n  border-radius: 17px;\r\n  padding: 5px 10px;\r\n  border-color: grey;\r\n}\r\n\r\n\r\n#stripoSettingsContainer>div>ul>li {\r\n  width: 180px !important;\r\n}\r\n\r\n\r\n/////-----------------------------------------------------------------------------\r\n// campaign list\r\n.ngx-datatable.material.no-campaigns-created .empty-row {\r\n  height: 350px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 500;\r\n  font-size: 25px;\r\n}\r\n\r\n/////-----------------------------------------------------------------------------\r\n// mat select \r\n.mat-active {\r\n  background: $nx-mat-option-active !important;\r\n}\r\n\r\n.cdk-overlay-pane {\r\n  position: absolute;\r\n  pointer-events: auto;\r\n  box-sizing: border-box;\r\n  z-index: 1000;\r\n  display: flex;\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  transform: none !important;\r\n}\r\n\r\n.mat-select-panel {\r\n  padding: 5px 0 !important;\r\n}\r\n\r\n/////-----------------------------------------------------------------------------\r\n// search header custom css\r\n\r\n\r\n.mat-mdc-form-field-subscript-wrapper {\r\n  height: 0px;\r\n}\r\n\r\n.blue-color>span {\r\n  font-weight: 900;\r\n  font-stretch: expanded;\r\n}\r\n\r\n.mat-mdc-form-field label {\r\n  color: $nx-grey;\r\n}\r\n\r\n.mdc-menu-surface.mat-mdc-autocomplete-panel {\r\n  padding: 0 !important;\r\n}\r\n\r\nmat-toolbar.mat-toolbar.mat-toolbar-single-row>div:nth-child(1) {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  justify-content: space-between;\r\n}\r\n\r\nmat-toolbar.mat-toolbar.mat-toolbar-single-row>div:nth-child(1)>div {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n\r\nmat-toolbar.mat-toolbar.mat-toolbar-single-row>div:nth-child(1)>div>div:nth-child(1) {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.search-wrap .mat-mdc-floating-label,\r\n.search-wrap .mat-mdc-form-field {\r\n  font-size: 14px;\r\n}\r\n\r\n.search-wrap .mat-mdc-form-field input {\r\n  margin-top: 2px;\r\n}\r\n\r\n.searchDropWrap .mdc-list-item__primary-text {\r\n  width: 100%;\r\n}\r\n\r\n.search-wrap .mdc-floating-label--float-above {\r\n  transform: translateY(-26.75px) scale(0.75) !important;\r\n}\r\n\r\n.search-wrap div[ng-reflect-open=\"true\"] .mdc-notched-outline__notch {\r\n  width: calc(126px * var(--mat-mdc-form-field-floating-label-scale, 0.75) + 9px) !important;\r\n}\r\n\r\n.search-wrap label:not(.mdc-floating-label--float-above) .search-lead {\r\n  color: $nx-dark-grey-search-placeholder ;\r\n}\r\n\r\n.mdc-floating-label {\r\n  will-change: unset !important;\r\n}\r\n\r\n.search-wrap mat-icon {\r\n  color: $nx-black;\r\n}\r\n\r\n@media only screen and (max-width: 598px) {\r\n  .search-wrap div[ng-reflect-open=\"true\"] .mdc-notched-outline__notch {\r\n    display: none;\r\n  }\r\n\r\n  .search-wrap .mat-mdc-form-field-infix {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .cdk-overlay-pane {\r\n    width: 100% !important;\r\n    box-shadow: 0px 2px 2px $nx-black;\r\n  }\r\n\r\n  .mdc-menu-surface {\r\n    min-width: 100vw !important;\r\n  }\r\n\r\n  .mdc-menu-surface.mat-mdc-autocomplete-panel {\r\n    padding: 2px 0 0 0 !important;\r\n  }\r\n\r\n  .search-lead {\r\n    display: none;\r\n  }\r\n\r\n}\r\n\r\n.full-height-weight {\r\n  width: 100%;\r\n  padding-top: 1px;\r\n}\r\n\r\n.mat-raised-button:not(.mat-elevation-z) {\r\n  box-shadow: unset !important;\r\n}\r\n\r\n\r\n.card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  word-wrap: break-word;\r\n  background-color: #fff;\r\n  background-clip: border-box;\r\n  border: 1px solid rgba(0, 0, 0, .125);\r\n  border-radius: .25rem;\r\n}\r\n\r\n.card-body {\r\n  padding: 10px !important;\r\n}\r\n\r\n.card-header {\r\n  padding: .75rem 1.25rem;\r\n  margin-bottom: 0;\r\n  background-color: rgba(0, 0, 0, .03);\r\n  border-bottom: 1px solid rgba(0, 0, 0, .125);\r\n}\r\n\r\n.card-header-actions {\r\n  display: block;\r\n  float: right;\r\n  margin-right: -.25rem;\r\n}\r\n\r\n.card-header-action {\r\n  padding: 0 .25rem;\r\n  color: #73818f;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
